import merchantView from "./MerchantView";

export default merchantView;
